import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  FindRepContactsQueryQuery,
  RepContact
} from "../../../../../../schemaTypes";

export const findRepContactsQuery = gql`
  query FindRepContactsQuery {
    findRepContacts {
      id
      role
      admin {
        id
        firstname
        lastname
        email
        phone
        createdAt
        updatedAt
      }
      user {
        id
        admin {
          firstname
          lastname
          email
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const newRepContactSubscription = gql`
  subscription NewRepContactSubscription {
    newRepContact {
      id
      role
      admin {
        id
        firstname
        lastname
        email
        phone
        createdAt
        updatedAt
      }
      user {
        id
        admin {
          firstname
          lastname
          email
        }
      }
      createdAt
      updatedAt
    }
  }
`;

type NewRepContactSubscriptionResult = {
  newRepContact: RepContact;
};

export function useFindRepContacts() {
  const { data, loading, subscribeToMore } = useQuery<FindRepContactsQueryQuery>(findRepContactsQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newRepContactSubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewRepContactSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findRepContacts: [
            ...prev.findRepContacts,
            subscriptionData.data.newRepContact
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    repContacts: data?.findRepContacts ?? [],
    loading
  };
}
